import { FieldConfig } from "../types/formTypes";

export interface FeeFieldConfig {
  id: string;
  title: string;

  // applicationData keys
  estimatedKey: string;
  actualKey: string;
  readyKey?: string;
  reimbursableKey?: string;

  // behavior flags
  reimbursable?: boolean;
  readOnly?: boolean; // Field is display-only (text area)
  helperText?: string; // Helper text to display below field
  hideReimbursable?: boolean; // Hide the reimbursable column
}

/**
 * Fee configuration data - only unique values
 * Keys follow predictable naming: est{Suffix}Fee, actual{Suffix}Fee, approved{Suffix}Fee
 */
const feeConfigData = [
  { id: "tuition", title: "Tuition fee", keySuffix: "Tution" },
  { id: "books", title: "Books fee", keySuffix: "Books" },
  { id: "lab", title: "Lab fees", keySuffix: "Lab" },
  { id: "registration", title: "Registration fees", keySuffix: "Regist" },
  { id: "other", title: "Other fees", keySuffix: "Other" },
  { id: "airfare", title: "Airfare + baggage fees", keySuffix: "AirfareBaggage" },
  { id: "autoRental", title: "Auto rental fees", keySuffix: "AutoRental" },
  { id: "hotel", title: "Hotel fees", keySuffix: "Hotel" },
  { id: "parking", title: "Parking + tolls fees", keySuffix: "ParkToll" },
  { id: "publicTransport", title: "Public transportation", keySuffix: "PublicTransport" },
  { id: "mileage", title: "Mileage total dollar value", keySuffix: "MilesDollarValue" },
] as const;

/**
 * Factory function to generate FeeFieldConfig from minimal data
 * Reduces duplication by generating predictable key names from keySuffix
 */
const createFeeConfig = (
  data: typeof feeConfigData[number],
  overrides?: Partial<FeeFieldConfig>
): FeeFieldConfig => ({
  id: data.id,
  title: data.title,
  estimatedKey:data.id== 'mileage' ? `est${data.keySuffix}` : `est${data.keySuffix}Fee`,
  actualKey: data.id== 'mileage' ? `actual${data.keySuffix}` : `actual${data.keySuffix}Fee`,
  reimbursableKey: data.id== 'mileage' ? `approved${data.keySuffix}` : `approved${data.keySuffix}Fee`,
  reimbursable: true,
  ...overrides,
});

/**
 * Reimbursement fields configuration
 * Generated from feeConfigData to eliminate structural duplication
 */
export const ReimbursementFieldsConfig: FeeFieldConfig[] = feeConfigData.map(
  (data) => createFeeConfig(data)
);

export const editFormFields: FieldConfig[] = [
  {
    name: "fileName",
    label: "File name",
    type: "text",
    disabled: true,
  },
  {
    name: "description",
    label: "Describe the contents",
    type: "text",
    required: true,
  },
];

// Admin document types
export const adminDocumentTypes = {
  gradesVerified: "Grades",
  receiptVerified: "Receipts",
  travelReceipts: "Travel receipts (NCAL Region only)",
  paystubVerified: "Pay stub",
  scheduleVerified: "Schedule",
  other: "Other 1",
};